import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface UIState {
  // State
  sidebarOpen: boolean
  themeName: string // e.g., 'default', 'adventure', 'ocean'
  themeMode: 'light' | 'dark' // Light or dark mode for current theme
  language: string // e.g., 'en-US', 'es-ES'
  loading: boolean
  error: string | null

  // Actions
  toggleSidebar: () => void
  setSidebarOpen: (open: boolean) => void
  setTheme: (themeName: string) => void
  setThemeMode: (mode: 'light' | 'dark') => void
  toggleThemeMode: () => void
  setLanguage: (language: string) => void
  setLoading: (loading: boolean) => void
  setError: (error: string | null) => void
  clearError: () => void
}

export const useUIStore = create<UIState>()(
  persist(
    set => ({
      // Initial state
      sidebarOpen: true,
      themeName: 'adventure', // Default theme
      themeMode: 'light', // Default to light mode
      language: 'en-US', // Default to English
      loading: false,
      error: null,

      // Actions
      toggleSidebar: () => set(state => ({ sidebarOpen: !state.sidebarOpen })),
      setSidebarOpen: open => set({ sidebarOpen: open }),
      setTheme: themeName => set({ themeName }),
      setThemeMode: themeMode => set({ themeMode }),
      toggleThemeMode: () =>
        set(state => ({
          themeMode: state.themeMode === 'light' ? 'dark' : 'light',
        })),
      setLanguage: language => set({ language }),
      setLoading: loading => set({ loading }),
      setError: error => set({ error }),
      clearError: () => set({ error: null }),
    }),
    {
      name: 'adventurecore-ui',
      partialize: state => ({
        themeName: state.themeName,
        themeMode: state.themeMode,
        language: state.language,
        sidebarOpen: state.sidebarOpen,
      }),
    }
  )
)
